import type { PensionFeatures } from '../types/PensionFeatures';

export const phoebeFlags: PensionFeatures = {
    pensions: {
        enabled: false,
        _description: 'Enables the whole pension product',
        newLayout: {
            enabled: false,
            _description: 'Enables the new pension layout - overview, settings, funds',
        },
        contributionPayment: {
            enabled: false,
            _description: 'Enables the contribution payment feature',
        },
        v2: {
            enabled: false,
            _description: 'Enables pension v2 behavior',
        },
        ticketing: {
            enabled: false,
            _description: 'Enables pension ticketing feature',
        },
        papiCustomization: {
            enabled: false,
            _description: 'Enables usage of PAPI customization.',
        },
    },
};
